import { create } from 'zustand';
import config from '../config';

const useTraitSwapStore = create((set) => ({
  activeTab: 0,
  selectedNfts: [],
  swappedLayers: [],
  failedTraitImages: [],
  initiateSwapSuccess: false,
  initiateSwapUpdates: null,

  dismissedFlaggedTraits: false,

  swapHistory: [],

  setActiveTab: (tab) => {
    set({ activeTab: tab, initiateSwapSuccess: false, initiateSwapUpdates: null });
  },
  selectNft: (nft) =>
    set((state) => {
      const isSelected = state.selectedNfts.some((selectedNft) => selectedNft.id === nft.id);
      let updatedNfts;

      if (isSelected) {
        updatedNfts = state.selectedNfts.filter((selectedNft) => selectedNft.id !== nft.id);
      } else if (state.selectedNfts.length < config.traitSwapMaxNfts) {
        updatedNfts = [...state.selectedNfts, nft];
      } else {
        updatedNfts = [state.selectedNfts[0]];
        updatedNfts.push(nft);
      }

      // Reset failedTraitImages when a new NFT is selected and reset swappedLayers
      return {
        selectedNfts: updatedNfts,
        failedTraitImages: [],
        swappedLayers: [],
        initiateSwapSuccess: false,
        initiateSwapUpdates: null,
        dismissedFlaggedTraits: false,
      };
    }),

  updateMetadata: (metadataArray) =>
    set((state) => {
      const updatedNfts = state.selectedNfts.map((selectedNft, index) => {
        const metadata = metadataArray[index];
        return metadata ? { ...selectedNft, metadata } : selectedNft;
      });
      return { selectedNfts: updatedNfts };
    }),

  swapLayer: (layer) =>
    set((state) => {
      if (state.failedTraitImages.length > 0) {
        return { swappedLayers: [] };
      }

      const isLayerAlreadySwapped = state.swappedLayers.includes(layer);
      const canAddMoreLayers = state.swappedLayers.length < config.traitSwapMaxLayers;

      const updatedSwappedLayers = isLayerAlreadySwapped
        ? state.swappedLayers.filter((existingLayer) => existingLayer !== layer)
        : canAddMoreLayers
        ? [...state.swappedLayers, layer]
        : state.swappedLayers;

      return {
        swappedLayers: updatedSwappedLayers,
        initiateSwapSuccess: false,
        initiateSwapUpdates: null,
        dismissedFlaggedTraits: false,
      };
    }),

  addFailedTraitImage: (image) =>
    set((state) => {
      const updatedFailedTraitImages = [...state.failedTraitImages, image];
      return { failedTraitImages: updatedFailedTraitImages, initiateSwapSuccess: false, initiateSwapUpdates: null };
    }),

  setInitiateSwapSuccess: (success) => set({ initiateSwapSuccess: success }),
  setInitiateSwapUpdates: (updates) => set({ initiateSwapUpdates: updates }),

  setDismissedFlaggedTraits: (dismissed) => set({ dismissedFlaggedTraits: dismissed }),

  reset: () =>
    set({
      activeTab: 0,
      selectedNfts: [],
      failedTraitImages: [],
      initiateSwapSuccess: false,
      initiateSwapUpdates: null,
      dismissedFlaggedTraits: false,
    }),
}));

export default useTraitSwapStore;
